import { AccountData, AccountType } from "../../../models/AccountData";
import { FeatureUseLimitCalculator } from "../../../models/featureUseLimits/FeatureUseLimitsCalculator";
import {
  FeatureUseStatus,
  OrgFeatures,
} from "../../../models/featureUseLimits/FeatureUseLimitsData.const";

export const canReplyFacilityReviews = (me: AccountData | undefined) => {
  if (me?.type === AccountType.ADMIN || me?.type === AccountType.LOC_ADMIN) {
    return true;
  }

  if (me?.type === AccountType.ORG_ADMIN) {
    return (
      FeatureUseLimitCalculator.getFeatureUseStatus(
        OrgFeatures.REPLY_FACILITY_REVIEWS,
        me.organization?.commonFeatureUseLimit
      ) === FeatureUseStatus.CAN_USE
    );
  }

  return false;
};
